import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

interface Props extends TooltipProps {
  withWrapper?: boolean;
}

export const Tooltip = ({ title, children, withWrapper = true, ...rest }: Props) => {
  if (withWrapper) {
    return (
      <MuiTooltip title={title} {...rest}>
        {/* div wrapper needed in case of providing tooltips for FCs otherwise we meet ref issues */}
        <div>{children}</div>
      </MuiTooltip>
    );
  }

  return (
    <MuiTooltip title={title} {...rest}>
      {children}
    </MuiTooltip>
  );
};
